<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <Carousal />
      </v-flex>
    </v-layout>
    <v-layout  wrap>
      <v-flex>
        <AboutHome />
      </v-flex>
    </v-layout>
    <v-layout pb-3 wrap>
      <v-flex>
        <v-parallax
          class="hidden-lg-and-up"
          height="600"
          src="../../assets/images/carousal/carousal6.jpg"
          contain
        >
          <ServiceBanner />
        </v-parallax>
        <v-parallax
          class="hidden-md-and-down"
          height="200"
          src="../../assets/images/carousal/carousal6.jpg"
          contain
        >
          <ServiceBanner />
        </v-parallax>
      </v-flex>
    </v-layout>
    <v-layout py-3 wrap>
      <v-flex>
        <BusinessSector />
      </v-flex>
    </v-layout>
    <v-layout py-3 wrap>
      <v-flex>
        <ServiceProvided />
      </v-flex>
    </v-layout>

    <v-layout py-3 wrap>
      <v-flex>
        <ClientHome />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import Carousal from '../Home/carousal'
import Carousal from "../Home/carousal";
import AboutHome from "../Home/aboutHome";
import ServiceBanner from "../Home/serviceBanner";
import ServiceProvided from "../Home/servicesHome";
import BusinessSector from "../Home/businessSector";
import ClientHome from "../Home/clientHome";
export default {
  components: {
    Carousal,
    AboutHome,
    ServiceBanner,
    ServiceProvided,
    BusinessSector,
    ClientHome,
  },
  data() {
    return {};
  },
};
</script>